window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-accordion-item:not(.in-backend)").forEach(item => {
    const title = item.querySelector(".c-title");
    title.addEventListener("click", onClick, {
      passive: true
    });
    const text = item.querySelector(".c-content");
    if (!text) {
      item.classList.remove("open");
      title.removeEventListener("click", onClick);
    }
    function onClick() {
      item.classList.toggle("open", !item.classList.contains("open"));
    }
  });
});